// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useContext, useState} from 'react';
import {Settings_context} from '../settings_ctx';
import {Editor} from '../../../shared/editor/editor';
import cn from 'classnames';
import styles from './related_articles.module.less';
import {Button} from '../../../shared/button';

interface i_article_card_props {
    article_url: string;
    img_src: string;
    publish_date: string;
    title: string;
    category: string;
    category_url: string;
    read_time: string;
}

const Article_card = (props: i_article_card_props)=>{
    const {article_url, img_src, publish_date, title, category,
        category_url, read_time} = props;
    const {theme} = useContext(Settings_context);
    return <div className={styles.article_card}>
      <a href={article_url} className={styles.image_link}>
        <img src={img_src} alt={title}/>
      </a>
      <div className={styles.text_container}>
        <p className={cn(theme.u3, styles.publish_date)}>{publish_date}</p>
        <a href={article_url}>
          <p className={cn([theme.p2, theme.med, theme.color_n700,
            styles.title])}>{title}</p>
        </a>
        <div className={styles.meta}>
          <a href={category_url}>
            <p className={cn(theme.p4, theme.med)}>{category}</p>
          </a>&nbsp;&bull;&nbsp;
          <p className={cn(theme.p4, theme.med)}>{read_time} read</p>
        </div>
      </div>
    </div>;
};

interface i_related_articles_props {
    title: string;
    cards: i_article_card_props[];
}

export const Related_articles = (props: i_related_articles_props)=>{
    return <div className={styles.container}>
      <div className={styles.title_container}>
        <h5 className={styles.title}>{props.title}</h5>
      </div>
      <div className={styles.cards}>
        {props.cards.map((card, idx)=>
          <Article_card key={idx} {...card}/>)}
      </div>
    </div>;
};

interface i_related_articles_editor_props {
    value: i_related_articles_props;
    on_change: (new_val: i_related_articles_props)=>void;
}

export const Related_articles_editor =({value, on_change}:
i_related_articles_editor_props)=>{
    const [state, set_state] = useState(value);
    return <Editor value={state}
      on_change={v=>{
        on_change(v);
        set_state(v);
      }} on_save={()=>on_change(state)}
      editors={[
        {key: 'title', label: 'Section Title', type: 'text'},
      ]}>
        <>
          {state.cards.map((c, i)=>
            <div key={i}>
              <Editor value={c}
                on_change={new_card=>{
                  const new_cards = [...state.cards];
                  new_cards[i] = new_card;
                  const new_state = {...state, cards: new_cards};
                  on_change(new_state);
                  set_state(new_state);
                }}
                on_save={()=>{
                  const new_state = {...state};
                  on_change(new_state);
                  set_state(new_state);
                }}
                editors={[
                  {key: 'article_url', label: 'Article URL', type: 'text'},
                  {key: 'img_src', label: 'Image URL', type: 'text'},
                  {key: 'publish_date', label: 'Publish Date', type: 'text'},
                  {key: 'title', label: 'Article Title', type: 'text'},
                  {key: 'category', label: 'Category', type: 'text'},
                  {key: 'category_url', label: 'Category URL', type: 'text'},
                  {key: 'read_time', label: 'Read Time', type: 'text'},
                ]}/>
              <Button caption="Delete card" size="xs"
                on_click={()=>{
                  set_state({
                    ...state,
                    cards: state.cards
                      .filter((_, index)=>index!=i)
                  });
                }}/>
              <hr/>
            </div>)
          }
          <Button caption="Add new card (max 3)" size="xs"
            on_click={()=>set_state(
              {...state,
                cards: [...state.cards, {article_url: '', img_src: '',
                  publish_date: '', title: '', category: '', category_url: '',
                  read_time: ''}]})} disabled={state.cards.length>=3}/>
        </>
      </Editor>;
};
